  <div class='modal-header'>
    <h5 class="modal-title" id="modal-basic-title">Device QR Code</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()" data-id="Dismiss QR Code Clicked"></button>
  </div>

  <div id="element"></div>
  <div class='modal-body' style="padding-left: 80px; padding-top: 10px;">
    <div id="qrCode"></div>
  </div>

  <div class='modal-footer'>
    <div class="float-end">
      <button ejs-button id="btnClearGroup" class="ms-2" (click)="activeModal.dismiss()" data-id="Close QR Code Clicked">Close</button>
    </div>
        <div class="float-end">
      <button ejs-button id="btnClearGroup" cssClass="e-primary" class="ms-2" (click)="Save()" data-id="Save QR Code Clicked">Save</button>
    </div>
  </div>